import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../helpers/notification_delegate';
import { APUserModeConfig } from '../user_mode_config/config/ap_user_mode_config';
import { ICourseDetailState } from './../../../routes/ap_course_details_routes';
import { ILoadCourseInfoCommand } from './commands/load_course_info_command';

export class CourseDetailController {
  private courseNk: string;
  private hideActions: boolean = false;
  private __openDrawer: boolean;
  private disableFavoriteOptions: boolean;
  private isFromSmartCat = false;
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ICourseDetailState['params'],
    private ngAPCourseInfoQuery: any,
    private loadCourseInfoCommand: ILoadCourseInfoCommand,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAPNotificationDelegate: INotificationDelegate,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any
  ) {}
  $onInit() {
    this.__openDrawer = true;
    this.disableFavoriteOptions = this.ngAPUserModeConfig.isAdvisor();
    const stateParams = this.$stateParams.courseDetails;
    this.isFromSmartCat = stateParams.isFromSmartCat || false;
    if (stateParams.slotType && stateParams.slotType !== 'COURSE') {
      this.hideActions = true;
    }
    this.loadCourseInfoCommand(stateParams.courseNk, stateParams.termId, stateParams.programSlotId).catch((e) => {
      this.closeDetails();
      this.ngAPNotificationDelegate.error(`Unable to load course details`);
    });
  }

  closeDetails() {
    this.__openDrawer = false;
    this.$state.go('^');
    this.phxFocusDelegate.focus(this.phxAxReturnFocusFactory.getFocusId());
  }
}
class APCourseDetails implements ng.IComponentOptions {
  public bindings: Record<string, string>;
  public controller: any;
  public templateUrl: any;
  public transclude: boolean;
  constructor() {
    this.controller = CourseDetailController;
    this.templateUrl = 'capability-ng-academic-planner/src/global/components/course_detail/course_detail.html';
    this.bindings = {
      hideActions: '<'
    };
    this.transclude = true;
  }
}

angular.module('capability-ng-academic-planner').component('apCourseDetails', new APCourseDetails());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/course_detail.ts